/**
 * 아래는 계산식 참고를 위한 BE에서 사용중인 aspose에 내장된 kotlin 코드로 작성된 ConvertUtil 클래스의 내용입니다.
 * object ConvertUtil {
 *      fun pointToPixel(points: Double): Double {
 *          val var4 = 96.0
 *          return points / 72.0 * var4
 *      }
 *      fun pointToPixel(points: Double, resolution: Double): Double {
 *          return points / 72.0 * resolution
 *      }
 *      fun pixelToPoint(pixels: Double): Double {
 *          val var4 = 96.0
 *          return pixels / var4 * 72.0
 *      }
 *      fun pixelToPoint(pixels: Double, resolution: Double): Double {
 *          return pixels / resolution * 72.0
 *      }
 *      fun inchToPoint(inches: Double): Double {
 *          return inches * 72.0
 *      }
 *      fun pointToInch(points: Double): Double {
 *          return points / 72.0
 *      }
 *      fun millimeterToPoint(millimeters: Double): Double {
 *          return millimeters * 2.834645669291339
 *      }
 * }
 */

export function convertToPt(valueWithUnit: string): number {
    const match = valueWithUnit.match(/^([\d.e+-]+)([a-z]+)$/);
    if (!match) return 0;

    const [, value, unit] = match;
    const numValue = parseFloat(value);

    if (Number.isNaN(numValue)) return 0;

    let result: number;
    switch (unit) {
        case 'px':
            result = numValue * 0.75; // px를 pt로 변환(96px = 72pt)
            break;
        case 'pt':
            result = numValue; // pt는 변환 없음
            break;
        case 'cm':
            result = numValue * 28.35; // cm를 pt로 변환(word에서 mm > pt 에서 2.835로 절삭하여 계산하는것으로 추정됨)
            break;
        case 'in':
            result = numValue * 72; // in를 pt로 변환
            break;
        default:
            throw new Error(`Unsupported unit: ${unit}`);
    }

    // 지수형태로 변환되지 않도록 소수점 자리수 제한하고 올림 처리
    const precision = 1000000; // 6자리 소수점
    return Math.ceil(result * precision) / precision;
}

export function convertToPx(valueWithUnit: string): number {
    const match = valueWithUnit.match(/^([\d.e+-]+)([a-z]+)$/);
    if (!match) return 0;

    const [, value, unit] = match;
    const numValue = parseFloat(value);

    if (Number.isNaN(numValue)) return 0;

    let result: number;
    switch (unit) {
        case 'px':
            result = numValue; // px는 변환 없음
            break;
        case 'pt':
            result = (numValue * 96) / 72; // pt를 px로 변환(72pt = 96px)
            break;
        case 'cm':
            result = numValue * 37.8; // cm를 px로 변환(word에서 mm > px 에서 37.8로 절삭하여 계산하는것으로 추정됨)
            break;
        case 'in':
            result = numValue * 96; // in를 px로 변환
            break;
        default:
            throw new Error(`Unsupported unit: ${unit}`);
    }

    // 지수형태로 변환되지 않도록 소수점 자리수 제한하고 올림 처리
    const precision = 1000000; // 6자리 소수점
    return Math.ceil(result * precision) / precision;
}
